import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { updateStatusInstance } from "../../../AdminAPI/UpdateStatusInstanceADM";
import getDocs from "../../../AdminAPI/DocsADM";
import { getInstanceADM } from "../../../AdminAPI/InstancesADM";
import "./RelaunchInstance.css";
import { useTranslation } from "react-i18next";
import RelaunchToast from "./RelaunchToast";

const RelaunchInstance = ({ instanceData, onClose }) => {
  const [loading, setLoading] = useState(false);
  const token = Cookies.get("Token");

  const [oldStatus, setOldStatus] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [availableStatuses, setAvailableStatuses] = useState([]);
  const [availableOldStatuses, setAvailableOldStatuses] = useState([]);
  const [kInstanceId, setKInstanceId] = useState("");
  const [kClientId, setKClientId] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [nbModified, setNbModified] = useState(0);
  const [nbDocs, setNbDocs] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    if (instanceData) {
      setKInstanceId(instanceData.kInstanceId);
      setKClientId(instanceData.kClientId);
    } else {
      setKInstanceId(Cookies.get("instanceId"));
      setKClientId(Cookies.get("clientId"));
    }
    setErrorMessage("");
  }, []);

  //fetch l'esemble de mes docs dans mon instance
  useEffect(() => {
    if (!kInstanceId || !kClientId) return; 

    const getDocInInstance = async () => {
      try {
        const fetchDocInstance = await getDocs(kInstanceId, kClientId, token);
        setNbDocs(fetchDocInstance.length);
        const uniqueOldStatuses = [
          ...new Set(
            fetchDocInstance
              .map((doc) => doc.OldStatus)
              .filter((status) => status)
          ),
        ];
        const uniqueStatuses = [
          ...new Set(
            fetchDocInstance.map((doc) => doc.Status).filter((status) => status)
          ),
        ];

        setAvailableStatuses(uniqueStatuses);
        setAvailableOldStatuses(uniqueOldStatuses);
      } catch (error) {
        console.error("error while fetch doc data : ", error);
      }
    };

    getDocInInstance();
  }, [kInstanceId, kClientId, token]); 

  const handleRelaunch = async () => {
    setErrorMessage("");

    if (!oldStatus || !currentStatus || !newStatus) {
      setErrorMessage(t("All fields must be completed."));
      return;
    }

    setLoading(true);
    try {
      // Récupérer les docs AVANT la mise à jour
      const docsBefore = await getDocs(kInstanceId, kClientId, token);
      const docsToUpdate = docsBefore.filter(
        (doc) => doc.Status === currentStatus && doc.OldStatus === oldStatus
      );

      // Faire la mise à jour
      await updateStatusInstance(
        oldStatus,
        currentStatus,
        newStatus,
        kInstanceId,
        "false",
        token
      );

      // Récupérer les docs APRÈS la mise à jour
      const docsAfter = await getDocs(kInstanceId, kClientId, token);
      const docsUpdated = docsAfter.filter((doc) =>
        docsToUpdate.some((d) => d.DocId === doc.DocId) && doc.Status === newStatus
      );

      setNbModified(docsUpdated.length);
      setToastOpen(true);
      setTimeout(() => window.location.reload(), 2000);
    } catch (error) {
      console.error("Erreur relance :", error);
      setErrorMessage(
         t("An error occurred during the relaunch of the instance.")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <RelaunchToast
        isOpen={toastOpen}
        nbModified={nbModified}
        nbSelected={nbDocs}
        onClose={() => setToastOpen(false)}
      />
      <div className="modal-container">
        <h3>{t("Restart the instance")}</h3>
        <p>{t("Please fill in the information for the follow-up :")}</p>

        <label>Instance Id : {kInstanceId}</label>

        <label>{t("OldStatus")} : </label>
        <select
          className="form-select"
          value={oldStatus}
          onChange={(e) => setOldStatus(e.target.value)}
        >
          <option value="">{t("Select an old status")}</option>
          {availableOldStatuses.map((status, index) => (
            <option key={index} value={status}>
              {status}
            </option>
          ))}
        </select>

        <label>{t("Current status :")}</label>
        <select
          className="form-select"
          value={currentStatus}
          onChange={(e) => setCurrentStatus(e.target.value)}
        >
          <option value="">{t("Select a status")}</option>
          {availableStatuses.map((status, index) => (
            <option key={index} value={status}>
              {status}
            </option>
          ))}
        </select>

        <label>{t("New status :")}</label>
        <input
          type="text"
          value={newStatus}
          onChange={(e) => setNewStatus(e.target.value)}
        />

        {errorMessage && (
          <div style={{ color: "red", marginTop: "10px" }}>{errorMessage}</div>
        )}

        <div className="modal-actions">
          <button
            className="btn_cancel"
            onClick={onClose}
            style={{ marginRight: "5px" }}
          >
            {t("Cancel")}
          </button>
          <button
            className="modal-button"
            onClick={handleRelaunch}
            disabled={loading}
          >
            {loading ? t("Treatment...") : t("Relaunch")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RelaunchInstance;
